import React from 'react';

const MentionsLegales = () => {
  return (
    <div className="w-full min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 sm:p-6 lg:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8">
            Mentions Légales
          </h1>

          <div className="space-y-4 sm:space-y-6 text-gray-700 text-sm sm:text-base">

            {/* 1. Éditeur du site */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                1. Éditeur du site
              </h2>
              <p className="mb-2"><strong>Association :</strong> Crions D’Couleurs</p>
              <p className="mb-2"><strong>Forme juridique :</strong> Association déclarée (loi 1901)</p>
              <p className="mb-2"><strong>Date de création :</strong> 04/02/2010</p>
              <p className="mb-2"><strong>SIREN :</strong> 522 833 714</p>
              <p className="mb-2"><strong>SIRET du siège social :</strong> 522 833 714 00028</p>
              <p className="mb-2"><strong>Code NAF/APE :</strong> 55.20Z – Hébergement touristique et autre hébergement de courte durée</p>
              <p className="mb-2"><strong>Siège social :</strong> Centre Social, 27 rue Notre-Dame, 35500 Vitré, France</p>
              <p className="mb-2"><strong>Responsable de la publication :</strong> Dorian Ménager, co-président de l’association Crions D’Couleurs</p>
              <p className="mb-2">
                <strong>Email :</strong>{' '}
                <a href="mailto:cdccolonies@gmail.com" className="text-blue-600 hover:underline">
                  cdccolonies@gmail.com
                </a>
              </p>
              <p className="mb-2">
                <strong>Téléphone :</strong>{' '}
                <a href="tel:0629606074" className="text-blue-600 hover:underline">
                  06.29.60.60.74
                </a>
              </p>
            </section>

            {/* 2. Hébergement */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                2. Hébergeur du site
              </h2>
              <p className="mb-2"><strong>Hébergeur :</strong> OVH SAS</p>
              <p className="mb-2">RCS Lille Métropole 424 761 419 00045</p>
              <p className="mb-2">Code APE : 2620Z</p>
              <p className="mb-2">N° TVA : FR 22 424 761 419</p>
              <p className="mb-2">Siège social : 2 rue Kellermann – 59100 Roubaix – France</p>
              <p className="mb-2">Téléphone : 1007</p>
              <p className="mb-2">
                Site web :{' '}
                <a href="https://www.ovh.com" className="text-blue-600 hover:underline">
                  www.ovh.com
                </a>
              </p>
            </section>

            {/* 3. Propriété intellectuelle */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                3. Propriété intellectuelle
              </h2>
              <p>
                L’ensemble du contenu de ce site (textes, images, vidéos, graphismes, logo, etc.)
                est la propriété exclusive de l’association Crions D’Couleurs, sauf mention contraire.
                Toute reproduction, diffusion ou exploitation, totale ou partielle, sans autorisation écrite
                préalable est strictement interdite et peut constituer une contrefaçon.
              </p>
              <p className="mt-2">
                Les marques et logos éventuellement présents sur le site sont la propriété de leurs détenteurs respectifs.
              </p>
            </section>

            {/* 4. Protection des données personnelles (RGPD) */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                4. Protection des données personnelles (RGPD)
              </h2>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Responsable du traitement</h3>
              <p className="mb-2"><strong>Association :</strong> Crions D'Couleurs</p>
              <p className="mb-2"><strong>Adresse :</strong> 27 Rue Notre-Dame, 35500 Vitré, France</p>
              <p className="mb-2"><strong>Email :</strong>{' '}
                <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">
                  crionsdcouleurs@gmail.com
                </a>
              </p>
              <p className="mb-2"><strong>Téléphone :</strong> 07 82 00 24 65</p>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Contact RGPD / Délégué à la Protection des Données</h3>
              <p className="mb-2">
                <strong>Contact RGPD :</strong>{' '}
                <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">
                  crionsdcouleurs@gmail.com
                </a>
              </p>
              <p className="text-sm text-gray-600">
                <em>Note : L'association n'a pas désigné de Délégué à la Protection des Données (DPO) car elle ne remplit pas les critères d'obligation
                (moins de 250 salariés, traitement de données de santé à petite échelle : ~150 enfants/an).</em>
              </p>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Vos droits</h3>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD – UE 2016/679) et à la loi
                Informatique et Libertés, vous disposez des droits suivants :
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
                <li>Droit d'accès (Art. 15)</li>
                <li>Droit de rectification (Art. 16)</li>
                <li>Droit à l'effacement / Droit à l'oubli (Art. 17)</li>
                <li>Droit à la limitation du traitement (Art. 18)</li>
                <li>Droit à la portabilité des données (Art. 20)</li>
                <li>Droit d'opposition (Art. 21)</li>
              </ul>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Exercer vos droits</h3>
              <p className="mb-2">
                Pour exercer ces droits, vous pouvez :
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Utiliser les fonctionnalités de votre compte (export de données, modification, suppression)</li>
                <li>Envoyer un email à :{' '}
                  <a href="mailto:crionsdcouleurs@gmail.com" className="text-blue-600 hover:underline">
                    crionsdcouleurs@gmail.com
                  </a>
                </li>
              </ul>
              <p className="mt-2 text-sm text-gray-600">
                <strong>Délai de réponse :</strong> Maximum 1 mois à compter de la réception de votre demande.
              </p>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Durées de conservation</h3>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Comptes parents inactifs : 3 ans après la dernière connexion (email de rappel avant suppression)</li>
                <li>Données comptables : <strong>10 ans</strong> (obligation légale, archivées et chiffrées)</li>
                <li>Documents et données de santé : 1 an après la fin du séjour</li>
                <li>Logs de connexion : 90 jours (parents) / 1 an (administrateurs)</li>
              </ul>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Registre des traitements</h3>
              <p className="text-sm">
                Le registre des activités de traitement (Art. 30 RGPD) est tenu par l'association et consultable sur demande.
              </p>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Réclamation CNIL</h3>
              <p className="mt-2">
                En cas de difficulté non résolue, vous pouvez adresser une réclamation à la CNIL :
              </p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li>En ligne :{' '}
                  <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    www.cnil.fr/fr/plaintes
                  </a>
                </li>
                <li>Par courrier : CNIL - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07</li>
              </ul>

              <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2 mt-4">Politique de confidentialité complète</h3>
              <p>
                Pour plus de détails sur le traitement de vos données personnelles, consultez notre{' '}
                <a href="/politique-confidentialite" className="text-blue-600 hover:underline font-semibold">
                  Politique de Confidentialité
                </a>.
              </p>
            </section>

            {/* 5. Responsabilité */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                5. Responsabilité
              </h2>
              <p>
                L’association Crions D’Couleurs s’efforce de fournir sur son site des informations exactes et à jour.
                Toutefois, elle ne saurait être tenue responsable des erreurs, omissions ou de l’indisponibilité du site.
                Elle se réserve le droit de modifier le contenu à tout moment et sans préavis.
              </p>
              <p className="mt-2">
                Le site peut contenir des liens vers d’autres sites internet ; l’association décline toute responsabilité
                quant au contenu de ces sites tiers.
              </p>
            </section>
          </div>

          <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-200">
            <p className="text-xs sm:text-sm text-gray-500">
              Dernière mise à jour : 16/01/2025 - Conformité RGPD renforcée
            </p>
            <p className="text-xs text-gray-400 mt-1">
              Ajout informations complètes RGPD : responsable du traitement, contact RGPD, durées de conservation, registre des traitements
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
